import React from 'react'
import classnames from 'classnames'
import {findApiV4Link, gaEvent} from 'shared'

export const DonateButton = ({ fundraisingEvent, className, gaAction }) => {
  if (fundraisingEvent.donations_prohibited) return null
  const donateUrl = findApiV4Link({ ofObject: fundraisingEvent, withRel: 'new_donation' })
  return <a
    className={classnames('btn btn-primary', className)}
    href={donateUrl}
    onClick={() => gaEvent('donation', gaAction)}
  >
    {I18n.t('misc.donate_button')}
  </a>
}
